//react-components
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

//Custom UI Components
import Calender from "../Calendar/Calender";

//Utils
import { checkIfNumber } from "../../Utils/Validations";

//Constants
import { DATE_FORMAT } from "../../Utils/Constants";

//Strings
import { Strings } from "../../Translations/i18n";

class SearchFilter extends React.Component {
  renderSelectionTextField = (singleFilter) => {
    return (
      <Col md={2} className="noPadding">
        <Form.Select
          size="md"
          type="text"
          placeholder={singleFilter.placeholder}
          componentClass="select"
          onChange={singleFilter.onChange}
          value={singleFilter.value}
          disabled={singleFilter.disabled}
          name={singleFilter.name}
        >
          {singleFilter.dropdownList.map((item) => {
            return (
              <option
                key={item.value}
                value={
                  singleFilter.name === "filterRole" ? item.role : item.value
                }
              >
                {singleFilter.name === "filterRole"
                  ? Strings(item.role)
                  : Strings(item.name)}
              </option>
            );
          })}
        </Form.Select>
      </Col>
    );
  };

  renderDateTextFields = (singleFilter) => {
    return (
      <Col md={2} className="noPadding">
        <Calender
          id={singleFilter.id}
          dateFormat={DATE_FORMAT}
          placeholder={singleFilter.placeholder}
          placeholderTopClass={singleFilter.placeholderTopClass}
          handleChange={singleFilter.onChange}
          value={singleFilter.value}
        />
      </Col>
    );
  };

  validateNumber = (event) => {
    if (!checkIfNumber(event) || event.shiftKey) {
      event.preventDefault();
    }
  };

  renderInputTextField = (singleFilter) => {
    return (
      <Col md={2} className="noPadding">
        <Form.Control
          id={singleFilter.id}
          type="text"
          placeholder={singleFilter.placeholder}
          onChange={singleFilter.onChange}
          value={singleFilter.value}
          disabled={singleFilter.disabled}
          name={singleFilter.name}
          maxLength={singleFilter.maxLength}
          onKeyDown={
            singleFilter.validateNumbersOnly
              ? this.validateNumber
              : () => {
                  //This is intensional
                }
          }
        />
      </Col>
    );
  };

  render() {
    return (
      <Row className=" noPadding">
        {this.props.filters.map((singleFilter) => {
          if (singleFilter.type === "select") {
            return this.renderSelectionTextField(singleFilter);
          } else if (singleFilter.type === "date") {
            return this.renderDateTextFields(singleFilter);
          } else {
            return this.renderInputTextField(singleFilter);
          }
        })}
        <Col md={2} className="noPadding centerAlign">
          <Button
            variant=""
            className="addOrUpdateUserTopButtons mx-1"
            size="sm"
            onClick={this.props.handleOnClickFilterSearch}
          >
            {Strings("search")}
          </Button>
          <Button
            variant=""
            className="addOrUpdateUserTopButtons"
            size="sm"
            onClick={this.props.handleOnClickResetSearchValues}
          >
            {Strings("reset")}
          </Button>
        </Col>
      </Row>
    );
  }
}

export default SearchFilter;
